import { atom } from "jotai";
import { SubmitAccessibility } from "common/apis";
import { atomWithLocalStorage } from "common/storage";

export const emailCheckWelcomeNameAtom = atom("");
export const emailAtom = atom("");
export const emailValidAtom = atom(false);
export const passwordAtom = atom("");
export const submitAccessibilityAtom = atom<SubmitAccessibility>({
  userId: 0,
  ability: "",
  how_do_you_hear_about_us_ids: "",
  accessibility_need_selection: "",
  makeDisabilityVisibleValue: false,
  accessibilityFeatureRequestTagsValue: "",
});
export const registeredUserIdAtom = atom(0);
export const drawerMenuOpenAtom = atom(false);
export const savedFiltersAppliedAtom = atom(false);
export const resetForgotPasswordCodeAtom = atom("");
export const messageForLoginModalAtom = atom("");
export const actionToPerformAfterLoginAtom = atom("");
export const actionToPerformValueAfterLoginAtom = atom("");
// Identifies which mounted surface initiated the pending post-login action, so
// that exactly one watcher resumes it (prevents stacked modals when several
// components watch the same action string). See AccessibilitySection / photo
// flag surfaces for usage.
export const actionToPerformOwnerAtom = atom("");
export const onboardingCompletedAtom = atomWithLocalStorage(
  "onboardingCompletedAtom",
  false,
);
// Own key, not the onboarding flag above — the hamburger menu resets that to
// replay the carousel, which would bring this hint back with it.
export const allPlacesHintDismissedAtom = atomWithLocalStorage(
  "allPlacesHintDismissed",
  false,
);
export const onboardingScreenAtom = atom(false);
export const onboardingCurrentScreenAtom = atom(0);
// Whether the "Ask AI" assistant is docked over the venue map column (desktop/tablet).
// Shared so the trigger (inside VenueSheetContent) and the dock (rendered in each
// page's map sidebar) stay in sync without prop-drilling through every page.
export const venueAssistantDockOpenAtom = atom(false);
